import type { Sizings_Bool_Exp, Sizing_Pumping_Type_Enum } from "gql/api";

export function sizingsByTextSearch(val?: string): Sizings_Bool_Exp {
  if (!val) {
    return {};
  }

  return {
    ...sizingsByTitle(val)
  };
}

export function sizingsByWellId(val: number): Sizings_Bool_Exp {
  if (typeof val === "undefined" || val === null) return {};

  return {
    well_id: {
      _eq: val
    }
  };
}

export function sizingsByWellName(val?: string): Sizings_Bool_Exp {
  if (!val) return {};

  return {
    well: {
      well_name: {
        _ilike: `%${val}%`
      }
    }
  };
}

export function sizingsByCustomerName(val?: string): Sizings_Bool_Exp {
  if (!val) return {};

  return {
    customer: {
      customer_name: {
        _ilike: `%${val}%`
      }
    }
  };
}

export function sizingsByCustomerERPId(
  is_customer: boolean,
  user_id: string,
  ERPids?: string[]
): Sizings_Bool_Exp {
  if (!ERPids || !is_customer) return {};

  return {
    _or: [
      {
        customer: {
          customer_erp_id: { _in: ERPids }
        },
        share_with_customer: { _eq: true },
        journal_author_id: { _neq: "import-user" }
      },
      {
        journal_author_id: { _eq: user_id },
        share_with_customer: { _eq: true }
      }
    ]
  };
}

export function sizingsByOwnerIdOrHalIdentifier(
  id?: string,
  hal_identifier?: string
): Sizings_Bool_Exp {
  if (!id) return {};

  return {
    _or: [
      {
        author: {
          hal_identifier: { _eq: hal_identifier }
        }
      },
      {
        journal_author_id: { _eq: id }
      }
    ]
  };
}

export function sizingsByOwnerName(name?: string): Sizings_Bool_Exp {
  if (!name) return {};

  return {
    _or: [
      { author: { display_name: { _ilike: `%${name}%` } } },
      {
        imported_from_sizing: {
          legacy_user: { display_name: { _ilike: `%${name}%` } }
        }
      }
    ]
  };
}

export function sizingsByTitle(title?: string): Sizings_Bool_Exp {
  if (!title) return {};

  return {
    _or: [
      { title: { _ilike: `%${title}%` } },
      {
        parent_sizing: { title: { _ilike: `%${title}%` } }
      }
    ]
  };
}

export function sizingsByDateRange(dates?: Date[]): Sizings_Bool_Exp {
  // if undefined or second date not set return empty object
  if (!dates || !dates[1]) return {};

  return {
    _and: [
      { journal_updated_at: { _gte: dates[0] } },
      { journal_updated_at: { _lte: dates[1] } }
    ]
  };
}

export function sizingsWhereNotDeleted(): Sizings_Bool_Exp {
  return {
    journal_deleted_at: { _is_null: true }
  };
}

export function sizingsByPumpingType(val?: string): Sizings_Bool_Exp {
  if (!val) return {};
  return {
    pumping_type: { _eq: val as Sizing_Pumping_Type_Enum }
  };
}
